import {Component, effect, inject, model, OnInit} from '@angular/core';
import {SessionService} from '../../@core/session.service';
import {HttpClient} from '@angular/common/http';
import {LaundryIconComponent} from './laundry-icon.component';
import {NzColDirective, NzRowDirective} from 'ng-zorro-antd/grid';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzOptionComponent, NzSelectComponent} from 'ng-zorro-antd/select';
import {firstValueFrom} from 'rxjs';
import {NzAlertComponent} from 'ng-zorro-antd/alert';


export interface LaundryStatus {
  type: string;
  id: string;
  num: number;
  status: string;
  left: number;
  updatedAt: Date;
  className: string;
}

export const convert = (raw: any[]): LaundryStatus[] => {
  return raw.map(r => ({
    type: r['Machine Type'],
    id: r['Machine ID'],
    num: parseInt(r['Machine ID']),
    status: r['Status'],
    left: parseInt(r['Left Time']),
    updatedAt: new Date(r['Last Update']),
    className: `${r['Machine Type']}${r['Machine ID']}`
  }));
};

export const Halls = [
  {
    'id': 'SR01',
    'code': '01',
    'abbr': 'Hall 1',
    'name': 'Jockey Club Humanity Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR02',
    'code': '02',
    'abbr': 'Hall 2',
    'name': 'HSBC Prosperity Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR03',
    'code': '03',
    'abbr': 'Hall 3',
    'name': 'Alumni Civility Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR04',
    'code': '04',
    'abbr': 'Hall 4',
    'name': 'Jockey Club Academy Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR05',
    'code': '05',
    'abbr': 'Hall 5',
    'name': 'Chan Sui Kau Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR06',
    'code': '06',
    'abbr': 'Hall 6',
    'name': 'Lee Shau Kee Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR07',
    'code': '07',
    'abbr': 'Hall 7',
    'name': 'Jockey Club Harmony Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR08',
    'code': '08',
    'abbr': 'Hall 8',
    'name': 'Yip Yuen Yuk Hing Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR09',
    'code': '09',
    'abbr': 'Hall 9',
    'name': 'Sir Gordon and Lady Ivy Wu Hall',
    'compound': 'KLT'
  },
  {
    'id': 'SR10',
    'code': '10',
    'abbr': 'Hall 10',
    'name': 'Student Residence Hall 10',
    'compound': 'KLT'
  },
  {
    'id': 'SR11',
    'code': '11',
    'abbr': 'Hall 11',
    'name': 'Student Residence Hall 11',
    'compound': 'KLT'
  },
  {
    'id': 'SR12-SR13',
    'code': '12',
    'abbr': 'Hall 12 & 13',
    'name': 'Student Residence Hall 12 & 13',
    'compound': 'MOS'
  },
  {
    'id': 'SR14',
    'code': '14',
    'abbr': 'Hall 14',
    'name': 'Student Residence Hall 14',
    'compound': 'MOS'
  },
  {
    'id': 'SR15',
    'code': '15',
    'abbr': 'Hall 15',
    'name': 'Student Residence Hall 15',
    'compound': 'MOS'
  },
  {
    'id': 'SR16',
    'code': '16',
    'abbr': 'Hall 16',
    'name': 'Student Residence Hall 16',
    'compound': 'MOS'
  },
  {
    'id': 'SR17',
    'code': '17',
    'abbr': 'Hall 17',
    'name': 'Student Residence Hall 17',
    'compound': 'MOS'
  }
];

export const Floors = [{'hall': 'SR17', 'floor': 8, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 12, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 7, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 14, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 8, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 6, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 16, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 9, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 17, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 3, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 8, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 16, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 1, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 8, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 11, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 9, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 5, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 10, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 6, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 12, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 4, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 5, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 1, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 7, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 3, 'gender': 'M'},
  {'hall': 'SR16', 'floor': 14, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 2, 'gender': 'M'},
  {'hall': 'SR14', 'floor': 15, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 11, 'gender': 'M'},
  {'hall': 'SR17', 'floor': 7, 'gender': 'F'},
  {'hall': 'SR16', 'floor': 13, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 7, 'gender': 'F'},
  {'hall': 'SR17', 'floor': 15, 'gender': 'F'},
  {'hall': 'SR14', 'floor': 14, 'gender': 'F'},
  {'hall': 'SR15', 'floor': 14, 'gender': 'M'},
  {'hall': 'SR15', 'floor': 4, 'gender': 'M'}];

@Component({
  selector: 'app-laundry-status',
  imports: [
    LaundryIconComponent,
    NzRowDirective,
    NzColDirective,
    ReactiveFormsModule,
    FormsModule,
    NzSelectComponent,
    NzOptionComponent,
    NzAlertComponent
  ],
  template: `
    @if (availableHalls.length > 0) {
      <nz-select style="width: 350px;" nzPlaceHolder="Please select a Hall" [(ngModel)]="hall">
        @for (ha of availableHalls; track ha.id) {
          <nz-option nzLabel="{{ha.abbr}} - {{ha.name}}" [nzValue]="ha"></nz-option>
        }
      </nz-select>
      <div class="container">
        <div class="title dryer-title">DRYERS</div>
        @for (r of machines; track r) {
          <div [className]="r.className">
            <app-laundry-icon [machine]="r"></app-laundry-icon>
          </div>
        }
        <div class="title washer-title">WASHERS</div>
      </div>
      <p>DISCLAIMER: The remaining time is an estimation, and will vary by user's behaviour.</p>
      <div class="legend">
        <nz-row [nzGutter]="[8,8]">
          <nz-col [nzXs]="24">
            <div class="title legends">Legends</div>
          </nz-col>
        </nz-row>
        <nz-row>
          <nz-col [nzXs]="24" [nzSm]="8" style="padding: 8px">
            <div style="display: flex; align-items: center">
              <img width="50px" src="assets/available.jpg"/>
              <div style="margin-left: 5px;">Available</div>
            </div>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="8" style="padding: 8px">
            <div style="display: flex; align-items: center">
              <img width="50px" src="assets/inuse.jpg"/>
              <div style="margin-left: 5px;">In Operation <br/>(31 Mins Left)</div>
            </div>
          </nz-col>
          <nz-col [nzXs]="24" [nzSm]="8" style="padding: 8px">
            <div style="display: flex; align-items: center">
              <img width="50px" src="assets/unavailable.jpg"/>
              <div style="margin-left: 5px;">Out of Service</div>
            </div>
          </nz-col>
        </nz-row>
      </div>
    } @else {
      <nz-alert nzMessage="Laundry status is not available"></nz-alert>
    }
  `,
  styles: `
    .container {
      margin-top: 10px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
      grid-template-rows: 30px 1fr 1fr 30px;
      gap: 2px;
      grid-template-areas:
    "DT DT DT DT DT DT DT DT"
    "D01 D02 D03 D04 D05 D06 D07 D08"
    "W01 W02 W03 W04 W05 W06 W07 W08"
    "WT WT WT WT WT WT WT WT";
    }

    .container div {
      background-color: #f5f1f1;
      padding: 2px;
    }

    .dryer-title {
      grid-area: DT;
    }

    .washer-title {
      grid-area: WT;
    }

    .title {
      font-weight: bold;
      text-align: center;
    }

    .D01 {
      grid-area: D01;
    }

    .D02 {
      grid-area: D02;
    }

    .D03 {
      grid-area: D03;
    }

    .D04 {
      grid-area: D04;
    }

    .D05 {
      grid-area: D05;
    }

    .D06 {
      grid-area: D06;
    }

    .D07 {
      grid-area: D07;
    }

    .D08 {
      grid-area: D08;
    }

    .W01 {
      grid-area: W01;
    }

    .W02 {
      grid-area: W02;
    }

    .W03 {
      grid-area: W03;
    }

    .W04 {
      grid-area: W04;
    }

    .W05 {
      grid-area: W05;
    }

    .W06 {
      grid-area: W06;
    }

    .W07 {
      grid-area: W07;
    }

    .W08 {
      grid-area: W08;
    }

    .legend {
      margin-top: 50px;
      font-weight: bold;
      font-size: 0.7rem;
    }

    .legends {
      background-color: #f5f1f1;
      height: 30px;
      display: flex;
      width: 100%;
      margin-bottom: 10px;
    }
  `
})
export class LaundryStatusComponent implements OnInit {

  user;
  hall = model(null);
  serviceUrl = 'https://misc.cityu-sro.hk/WMStatus';
  machines: LaundryStatus[] = [];
  private http: HttpClient = inject(HttpClient);
  availableHalls: any[] = [];

  constructor(private sess: SessionService) {
    this.user = this.sess.user();
    this.availableHalls = Halls.filter(h => {
      return this.user.halls.some(hid => h.id.includes(hid));
    });
    effect(() => {
      const hall = this.hall();
      if (hall) {
        this.load(hall).then();
      }
    });
  }

  async ngOnInit() {
    if (this.availableHalls.length === 1) {
      this.hall.set(this.availableHalls[0]);
    }
  }

  async load(hall: any) {
    const request = await firstValueFrom(this.http.get<any>(`${this.serviceUrl}/WMStatus.aspx?HallNo=${hall.code}`));
    this.machines = convert(request);

  }

}
